// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3rN7Y","colBig":"styles_colBig__2jv4D","colSmall":"styles_colSmall__2O2RT"};